import { ReactComponent as Tick } from "../../assets/icons/check_tick.svg";
import "./CheckBox.css";

const CheckBox = ({ checked }: { checked: boolean }) => {
  return (
    <div className="checkBox_wrapper center">
      {checked ? <Tick /> : ``}
      <input type="checkbox" name="" id="" hidden />
    </div>
  );
};

export default CheckBox;
